import Vue from "vue";
import Vuex from "vuex";
import authModule from "@store/modules/auth";
import globalModule from "@store/modules/global";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: { globalModule, authModule }
});
